module.exports = __webpack_public_path__ + "assets/images/0755e69384263cd30199c40e07ec4056.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/amex-mpj/amex-mpj-1.jpg
// module id = 798
// module chunks = 0